import { useIsAuth } from 'feature/auth/hooks'
import { getClientType } from 'feature/auth/redux/authStorage'
import { FC, Suspense } from 'react'
import { Navigate, Outlet } from 'react-router'

import { Loading } from './Loading'

// маршрут только для юридических лиц
export const CompanyRoute: FC = () => {
  const isAuth = useIsAuth()

  if (!isAuth) {
    return <Navigate to='/' replace />
  }

  if (getClientType() !== 'company') {
    return <Navigate to='/' replace />
  }

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  )
}
